import { render, staticRenderFns } from "./withdrawalDetails.vue?vue&type=template&id=524a37b0&scoped=true"
import script from "./withdrawalDetails.vue?vue&type=script&lang=js"
export * from "./withdrawalDetails.vue?vue&type=script&lang=js"
import style0 from "./withdrawalDetails.vue?vue&type=style&index=0&id=524a37b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524a37b0",
  null
  
)

export default component.exports